import React from 'react'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SubscriptionViewSF from '../../components/accountSettings/subscription/SubscriptionViewSF'

const SubscriptionPageUI = ({context, subscription, messageList, errorList, priceList, onSubscriptionChange}) =>
  <PrivatePageSF context={context} className='pg_acc_sub' centered={!subscription || !priceList || (errorList && errorList.length > 0)}
    backLink='/settings/account/prj' messageList={messageList} headerMessageKey='c_subscription'>
    {
      (!subscription || !priceList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      subscription && priceList &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings/account/prj' messageList={messageList} titleMessageKey='c_subscription' />
        <SubscriptionViewSF
          context={context}
          subscription={subscription}
          priceList={priceList}
          messageList={messageList}
          onSubscriptionChange={onSubscriptionChange}
        />
      </div>
    }
  </PrivatePageSF>

export default SubscriptionPageUI
